module.exports = __webpack_public_path__ + "img/wheel-left.9cf0593e.svg";